export default "__VITE_ASSET__d6ca0f43__"